<ion-item>
    <ion-label>{{ this.userToString(user) }}</ion-label>
    <pia3-user-avatar [user]="user" slot="end"></pia3-user-avatar>
</ion-item>
